// theme-bridge.js — translate CSS custom properties + body data-attrs into
// the `brand` object the prototype components expect. No hardcoded brand
// palettes — fcc.cc and weatherdog both drive everything from the cascade.

const FALLBACK = {
  bg:          '#0c0d0f',
  panel:       '#111214',
  panelHi:     '#16181c',
  text:        '#f5f6f7',
  textDim:     '#9aa3b2',
  border:      '#2a2a2a',
  line:        '#1e1e1e',
  accent:      '#c7d2fe',
  accentDeep:  '#818cf8',
  eyebrowFont: 'ui-monospace, "SF Mono", Menlo, monospace',
  wordmark:    'fcc.cc',
  tagline:     'Weather',
  icon:        'fcc',
};

function readVar(name, fallback) {
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

export function readBrand() {
  const ds = document.body?.dataset || {};
  return {
    bg:          readVar('--brand-bg',         FALLBACK.bg),
    panel:       readVar('--brand-panel',      FALLBACK.panel),
    panelHi:     readVar('--brand-panel-hi',   FALLBACK.panelHi),
    text:        readVar('--brand-text',       FALLBACK.text),
    textDim:     readVar('--brand-text-dim',   FALLBACK.textDim),
    border:      readVar('--brand-border',     FALLBACK.border),
    line:        readVar('--brand-line',       FALLBACK.line),
    accent:      readVar('--brand-accent',     FALLBACK.accent),
    accentDeep:  readVar('--brand-accent-deep',FALLBACK.accentDeep),
    eyebrowFont: ds.brandEyebrowFont          || FALLBACK.eyebrowFont,
    wordmark:    ds.brandWordmark             || FALLBACK.wordmark,
    tagline:     ds.brandTagline              || FALLBACK.tagline,
    accentLabel: ds.brandAccentLabel          || 'The Almanac · Forecast',
    icon:        ds.brandIcon                 || FALLBACK.icon,
    name:        ds.brandName                 || ds.brandWordmark || FALLBACK.wordmark,
  };
}

export function readBrandKey() {
  return document.body?.dataset?.brandKey || (document.body?.dataset?.brandIcon === 'paw' ? 'weatherdog' : 'fcc');
}

export const DENSITY = {
  comfortable: { gap: 14, pad: 16, fs: 1.0,  rowH: 56, hourW: 60 },
  compact:     { gap: 9,  pad: 12, fs: 0.92, rowH: 48, hourW: 52 },
};
